import React from "react";
import { observer } from "mobx-react";
import { PlatformLinkTypeViewStore } from "../../store";
import { PlatformLinkTypeViewForm } from "./PlatformLinkTypeViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type PlatformLinkTypeViewProps = {
  platformLinkTypeViewStore: PlatformLinkTypeViewStore;
};

export const PlatformLinkTypeView: React.FC<PlatformLinkTypeViewProps> =
  observer(({ platformLinkTypeViewStore }) => {
    return (
      <div>
        <PlatformLinkTypeViewForm
          name={platformLinkTypeViewStore.nameValue}
          onPrint={(handlePrint: () => void) =>
            platformLinkTypeViewStore.printPlatformLinkType(handlePrint)
          }
          onCancel={() => platformLinkTypeViewStore.cancelPlatformLinkType()}
          onEdit={
            platformLinkTypeViewStore.isEditEnabled
              ? () => platformLinkTypeViewStore.editPlatformLinkType()
              : undefined
          }
        />
        <ErrorDialog
          open={platformLinkTypeViewStore.errorDialogOpened}
          title={platformLinkTypeViewStore.errorTitle}
          description={platformLinkTypeViewStore.errorDescription}
          onClose={() => platformLinkTypeViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
